import React, { useState, useEffect, useContext } from "react";
import Axios from "axios";
import { API_URL } from "../components/api";

import Select from "react-select";
import AuthContext from "../context/AuthContext";

function EditIPTV(props) {
  let [notes, setvillage] = useState([]);
  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  console.log(props.iptv_id);
  let exp = props.expiry;
  console.log(exp);
  function refreshPage() {
    window.location.reload(false);
  }

  useEffect(() => {
    let isMounted = true;

    const getIPTVAddon = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/plans/iptv`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: "admin",
          },
        });

        if (response.status === 200 && isMounted) {
          setvillage(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getIPTVAddon();

    return () => {
      isMounted = false;
    };
  }, []);

  const options = notes.map((item) => {
    return {
      label: item.package_name,
      value: item.iptv_plan_id,
    };
  });

  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [note, setNote] = useState("");
  const [name, setName] = useState("");
  const [pack, setPack] = useState("");
  const [expiry, setExpiry] = useState("");

  let handleSubmit = async (e) => {
    e.preventDefault();
    Axios.post(
      `${API_URL}/radius/subscriptions/iptv/`,
      {
        Action: "Put",
        iptv_id: props.iptv_id,
        code: code,
        password: password,
        name: name,
        notes: note,
        iptv_plan_id: pack,
        expiry_date: expiry,
        userdealer: user.username,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        refreshPage();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="name">
            <div className="form-group">
              <label>
                Name:
                <input
                  className="form-control"
                  type="text"
                  value={name}
                  placeholder="Name"
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                Username:
                <input
                  className="form-control"
                  type="text"
                  value={code}
                  placeholder={props.code}
                  onChange={(e) => setCode(e.target.value)}
                />
              </label>
            </div>

            <div className="form-group">
              <label>
                Password:
                <input
                  className="form-control"
                  type="text"
                  value={password}
                  placeholder={props.password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>
            </div>
          </div>

          <label>
            Notes:
            <input
              className="form-control"
              type="text"
              value={note}
              placeholder={props.notes}
              onChange={(e) => setNote(e.target.value)}
            />
          </label>

          <label>
            Package:
            <Select
              className="search-line"
              placeholder={props.plan}
              options={options}
              onChange={(opt) => setPack(opt.value)}
            />
          </label>
          <label>
            Expiry Date:
            <input
              type="date"
              id="expiryDate"
              name="expiryDate"
              className="form-control"
              value={exp}
              defaultValue={exp ? exp.substr(0, 10) : ""}
              onChange={(e) => setExpiry(e.target.value)}
            />
          </label>
          <div className="fo">
            <button
              type="submit"
              className="btn btn-primary btn-md"
              //onClick={() => {
              //props.parentFunction();
              //}}
            >
              Edit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditIPTV;
